<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentFollowUp.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: 'Home', href: '/' },
          {
            text: $t('studentFollowUp.pageTitle'),
            href: '/student-follow-ups'
          },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-5 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <ts-input
              class="form-control d-block mb-2"
              v-model="searchStudentTextLeftSide"
              :placeholder="$t('search')"
            />
          </ts-card-wrapper>
          <div
            class="overflow-auto"
            style="max-height: 1vh; min-height: 500px;"
          >
            <ts-table
              :loading="loading"
              :columns="columns"
              :records="availableStudentsLeftSide"
            >
              <template v-slot="{ record }">
                <td>
                  <ts-checkbox
                    :value="record.inquiry_id"
                    v-model="selectedStudentIdLeftSide"
                  ></ts-checkbox>
                </td>
                <td>{{ record.created_date }}</td>
                <td>{{ record.full_name_en }}</td>
                <td class="text-center">{{ record.gender }}</td>
                <td>{{ record.contact_name }}</td>
                <td class="text-center">{{ record.contact_number }}</td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper></ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-sm-4 col-lg-1 col-md-2">
        <div class="text-center" style="max-height: 1vh; min-height: 500px;">
          <div style="padding-top:200px;">
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="selectedItemToRightSide"
                :disabled="selectedStudentIdLeftSide.length <= 0"
              >
                <i class="fas fa-angle-right text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="allItemToRightSide"
                :disabled="StudentsLeftSide.length <= 0"
              >
                <i class="fas fa-angle-double-right text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="selectedItemToLeftSide"
                :disabled="selectedStudentIdRightSide.length <= 0"
              >
                <i class="fas fa-angle-left text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="allItemToLeftSide"
                :disabled="model.seletedStudentIds.length <= 0"
              >
                <i class="fas fa-angle-double-left text-primary fa-3x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-6 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-8 ts-flex">
                <ts-input
                  class="form-control d-block mb-2 ts-mr-2"
                  v-model="searchStudentTextRightSide"
                  :placeholder="$t('search')"
                />
                <label>Action Date</label>
                <ts-date-picker-input v-model="model.action_date" />
              </div>
              <div class="col-md-4 text-right">
                <ts-button
                  class="mr-2"
                  @click.prevent="$router.push({ name: 'student-follow-up' })"
                  >Cancel</ts-button
                >
                <ts-button
                  color="primary"
                  outline
                  :waiting="waiting_save_add_new"
                  @click.prevent="saveAddNew"
                  >{{ $t('save_add_new') }}</ts-button
                >
                <ts-button
                  class="ml-2"
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="save"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
          <div
            class="overflow-auto"
            style="max-height: 1vh; min-height: 500px;"
          >
            <ts-table
              :loading="loading"
              :columns="columns"
              :records="availableStudentRightSide"
            >
              <template v-slot="{ record }">
                <td>
                  <ts-checkbox
                    :value="record.inquiry_id"
                    v-model="selectedStudentIdRightSide"
                  ></ts-checkbox>
                </td>
                <td>{{ record.created_date }}</td>
                <td>{{ record.full_name_en }}</td>
                <td class="text-center">{{ record.gender }}</td>
                <td>{{ record.contact_name }}</td>
                <td class="text-center">{{ record.contact_number }}</td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper>
            <div class="validate" v-if="errors.has('inquiry_id_list')">
              {{ errors.first('inquiry_id_list') }}
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'student-follow-up-create',
  data () {
    return {
      model: {
        seletedStudentIds: [],
        action_date: moment().format('DD-MM-YYYY')
      },
      StudentsLeftSide: [],
      selectedStudentIdLeftSide: [],
      selectedStudentIdRightSide: [],
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_save_add_new: false,
      searchStudentTextLeftSide: '',
      searchStudentTextRightSide: ''
    }
  },
  created () {
    this.fetchStudentInquiry()
  },
  computed: {
    ...mapState('studentFollowUp', ['infoInquiries']),

    columns () {
      return [
        {
          name: this.$t('')
        },
        {
          name: this.$t('infoinquiry.date')
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.nameEn'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.gender'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactName'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactNumber'
          ),
          style: 'text-align:center;'
        }
      ]
    },

    availableStudentsLeftSide () {
      return this.StudentsLeftSide.filter(p => {
        let excluded = !_.includes(
          this.model.seletedStudentIds.map(_p => _p),
          p.inquiry_id
        )

        if (this.searchStudentTextLeftSide.trim() !== '') {
          return (
            p.full_name_en
              .toLowerCase()
              .includes(this.searchStudentTextLeftSide.toLowerCase().trim()) &&
            excluded
          )
        }

        return excluded
      })
    },

    availableStudentRightSide () {
      return this.infoInquiries.filter(p => {
        let included = _.includes(
          this.model.seletedStudentIds.map(_p => _p),
          p.inquiry_id
        )

        if (this.searchStudentTextRightSide.trim() !== '') {
          return (
            p.full_name_en
              .toLowerCase()
              .includes(this.searchStudentTextRightSide.toLowerCase().trim()) &&
            included
          )
        }

        return included
      })
    }
  },
  methods: {
    fetchStudentInquiry (attributes) {
      this.loading = true
      this.$store
        .dispatch('studentFollowUp/fetchInfoInquiries', attributes)
        .then(response => {
          this.studentInquiries = response
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    selectedItemToRightSide () {
      this.selectedStudentIdRightSide = []
      this.selectedStudentIdLeftSide.map(p =>
        this.model.seletedStudentIds.push(p)
      )
      this.selectedStudentIdLeftSide = []
    },

    allItemToRightSide () {
      this.selectedStudentIdRightSide = []
      this.model.seletedStudentIds = this.StudentsLeftSide.map(
        p => p.inquiry_id
      )
    },

    selectedItemToLeftSide () {
      this.selectedStudentIdLeftSide = []
      this.selectedStudentIdRightSide.map(el => {
        this.model.seletedStudentIds.splice(
          this.model.seletedStudentIds.indexOf(el),
          1
        )
      })
      this.selectedStudentIdRightSide = []
    },

    allItemToLeftSide () {
      this.selectedStudentIdLeftSide = []
      this.model.seletedStudentIds = []
    },

    clear () {
      ;(this.StudentsLeftSide = []),
        (this.selectedStudentIdLeftSide = []),
        (this.selectedStudentIdRightSide = []),
        (this.model.seletedStudentIds = [])
    },

    clearForm () {
      ;(this.StudentsLeftSide = []),
        (this.selectedStudentIdLeftSide = []),
        (this.selectedStudentIdRightSide = []),
        (this.model.seletedStudentIds = []),
        (this.model.location_id = '')
    },

    async save () {
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('studentFollowUp/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-follow-up' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_add_new = true

      this.$store
        .dispatch('studentFollowUp/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting_save_add_new = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting_save_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    infoInquiries: {
      handler (val) {
        if (_.isEqual(val)) return
        this.StudentsLeftSide = val
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-follow-up') {
      this.$store.commit('studentFollowUp/SET_INFO_INQUIRIES', [])
    }
    next()
  }
}
</script>
